import React, { useState } from 'react';
import { Form } from 'antd';
import { CustomButton } from '../../uikit/Button';
import { CustomInput } from '../../uikit/Input';
import { connect } from 'react-redux';
import http from "../../api";
import { toast } from "react-toastify";
import { CheckCircleOutlined } from '@ant-design/icons';
import { ReactComponent as Keyicon } from '../../assets/formicons/key.svg'; 
import './BaseProfile.scss';

const SecurityProfile = (props) => {
	const [ form ] = Form.useForm();
	const { currentUser } = props;

	const [ errors, setErrors ] = useState({});

	const handleChange = (e, name) => {
		setErrors(prevState => ({
			...prevState,
			[name]: ''
		}));
	}

	const handleFinish = (values) => {
		http(`/api/v1/user/change-password`, {
			method: 'PUT',
			data: values
				})
				.then((res) => {

			toast.success(
				<div className="toast-body">
					<CheckCircleOutlined className="toast__icon toast__icon--success" />
					<p className="toast-text">{`Password has been changed`}</p>
				</div>)
				})
				.catch(err => {
			if (!!err.response && !!err.response.data && !!err.response.data.errors) {
				setErrors(err.response.data.errors)
			}
				});
	};

	return (
		<div className="baseView">
			<div className="left">
				<Form
					layout="vertical"
					form={form}
					onFinish={handleFinish}
					initialValues={currentUser}
					hideRequiredMark
					style={{width: '100%'}}
				>
					<CustomInput
						label="Nuvarande lösenord"
						name="oldPassword"
						className={
							form.getFieldValue('password') &&
							form.getFieldValue('password').length > 0 &&
							"password"
						}
						validateStatus={ !!errors.oldPassword ? 'error' : ''}
						help={!!errors.oldPassword ? String(errors.oldPassword) : null}
						onChange={(e) => handleChange(e, 'oldPassword')}
						inputprops={{
							type: 'password',
							placeholder: 'Nuvarande lösenord',
							prefix: <Keyicon />
						}}
					/>

					<CustomInput
						name="password"
						label="Nytt lösenord"
						className={
							form.getFieldValue('password') &&
							form.getFieldValue('password').length > 0 &&
							"password"
						}
						validateStatus={ !!errors.password ? 'error' : ''}
						help={!!errors.password ? String(errors.password) : null}
						onChange={(e) => handleChange(e, 'password')}
						inputprops={{
							type: 'password',
							placeholder: 'Nytt lösenord',
							prefix: <Keyicon />
						}}
					/>
					<CustomInput
						label="Bekräfta lösenord"
						name="passwordConfirmation"
						className={
							form.getFieldValue('password') &&
							form.getFieldValue('password').length > 0 &&
							"password"
						}
						validateStatus={ !!errors.passwordConfirmation ? 'error' : ''}
						help={!!errors.passwordConfirmation ? String(errors.passwordConfirmation) : null}
						onChange={(e) => handleChange(e, 'passwordConfirmation')}
						inputprops={{
							type: 'password',
							placeholder: 'Bekräfta lösenord',
							prefix: <Keyicon />
						}}
					/>

					<Form.Item>
						<div className="buttons" style={{width: 250, margin: '20px auto 0'}}>
							<CustomButton 
								buttontype="type5"
								colortype="type8"
								size="large"
								htmlType="submit"
							>
								Uppdatera
							</CustomButton>
						</div>
					</Form.Item>
				</Form>
			</div>
			<div className="right">{/* <AvatarView avatar={getAvatarURL()} />*/}</div>
		</div>
	);
};

const mapStateToProps = (store) => {
	return {
	  currentUser: store.me.profile,
	};
  };
  
  export default connect(mapStateToProps)(SecurityProfile);
